
import {Container} from "react-bootstrap";
import SkinVoteList from "../components/Votes/SkinVote/SkinVoteList";

const SkinVote = () => {
    return (
        <Container>
            <SkinVoteList/>
        </Container>
    );
};

export default SkinVote;